import { render } from "./ApiHandler.vue?vue&type=template&id=28a69c4f"
import script from "./ApiHandler.vue?vue&type=script&lang=js"
export * from "./ApiHandler.vue?vue&type=script&lang=js"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__